//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import PaymentsAndCurrenciesPayments from '~/views/PaymentsAndCurrenciesSystem/PaymentsAndCurrenciesPayments/PaymentsAndCurrenciesPayments.vue';
import PaymentsAndCurrenciesP2PPayments from '~/views/PaymentsAndCurrenciesSystem/PaymentsAndCurrenciesP2PPayments/PaymentsAndCurrenciesP2PPayments.vue';

export default {
  components: {
    PaymentsAndCurrenciesPayments,
    PaymentsAndCurrenciesP2PPayments,
  },

  async mounted() {
    this.setGeneralLoader(true);
    if (this.$utils.getAppType() === 'strike') await this.loadCitiesAction();
    await Promise.allSettled([
      this.loadPayments(),
      this.loadCountriesAction(),
      this.loadCryptoCurrencies(),
      this.loadCryptoTokens(),
      this.loadPaymentMethods(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('paymentsAndCurrenciesPayments', {
      loadPayments: 'loadData',
      loadCryptoCurrencies: 'loadCryptoCurrencies',
      loadCryptoTokens: 'loadCryptoTokens',
    }),
    ...mapActions('paymentMethodsAndCurrenciesPaymentMethods', {
      loadPaymentMethods: 'loadData',
      loadCountriesAction: 'getCountries',
      loadCitiesAction: 'getCities',
    }),
  },
};
